///jacques-andre-editeur\proshop-v2\frontend\src\slices\authorsApiSlice.js
import { AUTHORS_URL } from '../constants';
import { apiSlice } from './apiSlice';

export const authorsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAuthors: builder.query({
      query: ({ keyword, pageNumber, isAdminSpace, sortKey, sortDirection, parPage }) => ({
        url: AUTHORS_URL,
        params: { keyword, pageNumber, isAdminSpace, sortKey, sortDirection, parPage },
      }),
      keepUnusedDataFor: 5,
      providesTags: ['Author'],
    }),

    getAllAuthors: builder.query({
      query: ({ keyword }) => ({
        url: `${AUTHORS_URL}/all`,
        params: { keyword },
      }),
      keepUnusedDataFor: 5,
      providesTags: ['Author'],
    }),

    getAuthorDetailsById: builder.query({
        query: ({ authorId, isAdminSpace }) => ({
          url: `${AUTHORS_URL}/${authorId}`,
          params: { isAdminSpace },
        }),
        keepUnusedDataFor: 5,
        providesTags: (result, error, authorId) => [{ type: 'Author', id: authorId }],
      }),
    
    getAuthorDetails: builder.query({
      query: ({ slug, isAdminSpace }) => ({
        url: `${AUTHORS_URL}/slug/${slug}`, // Modification pour appeler l'API avec le slug
        params: { isAdminSpace },
      }),
      keepUnusedDataFor: 5,
      providesTags: (result, error, slug) => [{ type: 'Author', id: slug }],
    }),

    createAuthor: builder.mutation({
        query: (data) => ({
          url: `${AUTHORS_URL}`,
          method: 'POST',
          body: data,
          credentials: 'include',
        }),
        invalidatesTags: ['Author'],
      }),

    updateAuthor: builder.mutation({
      query: (data) => {        
        return {
          url: `${AUTHORS_URL}`,
          method: 'PUT',
          body: data,
        };
      },
      invalidatesTags: ['Author'],
    }),

    deleteAuthor: builder.mutation({
      query: (authorId) => ({
        url: `${AUTHORS_URL}/${authorId}`,
        method: 'DELETE',
    }),
      invalidatesTags: ['Author'],
    }),

    toggleAuthorVisibility: builder.mutation({
      query: (authorId) => ({
        url: `${AUTHORS_URL}/${authorId}/visibility`,
        method: 'PUT',
      }),
      invalidatesTags: ['Author'],
    }),

    toggleAuthorInList: builder.mutation({
      query: (authorId) => ({
        url: `${AUTHORS_URL}/${authorId}/inList`,
        method: 'PUT',
      }),
      invalidatesTags: ['Author'],
    }),
  }),
});

export const {
    useGetAuthorsQuery,
    useGetAllAuthorsQuery,
    useGetAuthorDetailsQuery,
    useGetAuthorDetailsByIdQuery,
    useCreateAuthorMutation,
    useUpdateAuthorMutation,
    useToggleAuthorVisibilityMutation,
    useToggleAuthorInListMutation,
    useDeleteAuthorMutation,
  } = authorsApiSlice;
